export default __webpack_public_path__ + "static/media/caravan-club-logo.43bad9eb.png";